import React, { Component, PropTypes } from 'react';
import { Col, FormGroup } from 'react-bootstrap';
import GeneralExcess from '../../coverNoteCVComponent/generalExcess/GeneralExcess';
import ThirdPartyPropertyDamageExcess from '../../coverNoteCVComponent/thirdPartyPropertyDamageExcess/ThirdPartyPropertyDamageExcess';
import TheftLossExcess from '../../coverNoteCVComponent/theftLossExcess/TheftLossExcess';
import UnnamedDriverExcess from '../../coverNoteCVComponent/unnamedDriverExcess/UnnamedDriverExcess';
import YoungDriverExcess from '../../coverNoteCVComponent/youngDriverExcess/YoungDriverExcess';
import InexperienceDriverExcess from '../../coverNoteCVComponent/inexperienceDriverExcess/InexperienceDriverExcess';
import Remark from '../../coverNoteCVComponent/remark/Remark';

class ExcessDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: []
    }
  }

  render() {
    return (
      <div className="ebaoUtil__Top-Bottom-Line">
        <h3 className="ebaoUtil__HeaderThree">Excess Detail</h3>
          <FormGroup controlId="">
            <Col sm={6}>
              <GeneralExcess
                generalExcess={this.props.excessDetail.generalExcess}
                handleChangeGeneralExcess={this.props.handleChangeExcessDetail}
               />
            </Col>
            <Col sm={6}>
               <TheftLossExcess
                 theftLossExcess={this.props.excessDetail.theftLossExcess}
                 handleChangeTheftLossExcess={this.props.handleChangeExcessDetail}
               />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <UnnamedDriverExcess
                unnamedDriverExcess={this.props.excessDetail.unnamedDriverExcess}
                handleChangeUnnamedDriverExcess={this.props.handleChangeExcessDetail}
              />
            </Col>
            <Col sm={6}>
              <ThirdPartyPropertyDamageExcess
                thirdPartyPropertyDamageExcess={this.props.excessDetail.thirdPartyPropertyDamageExcess}
                handleChangeThirdPartyPropertyDamageExcess={this.props.handleChangeExcessDetail}
               />
            </Col>
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <YoungDriverExcess
                youngDriverExcess={this.props.excessDetail.youngDriverExcess}
                handleChangeYoungDriverExcess={this.props.handleChangeExcessDetail}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <InexperienceDriverExcess
                inexperienceDriverExcess={this.props.excessDetail.inexperienceDriverExcess}
                handleChangeInexperienceDriverExcess={this.props.handleChangeExcessDetail}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
          <FormGroup controlId="">
            <Col sm={6}>
              <Remark
                remark={this.props.excessDetail.remark}
                handleChangeRemark={this.props.handleChangeExcessDetail}
              />
            </Col>
            <Col sm={6} />
          </FormGroup>
      </div>
    )
  }
}

ExcessDetail.propTypes = {
  excessDetail: PropTypes.object,
  handleChangeExcessDetail: PropTypes.func,
};

export default ExcessDetail;



// WEBPACK FOOTER //
// ./src/app/components/coverNoteCVComponent/excessDetail/ExcessDetail.js